/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SandboxPriceRate,
  SandboxPriceRate$inboundSchema,
  SandboxPriceRate$Outbound,
  SandboxPriceRate$outboundSchema,
} from "./sandboxpricerate.js";

export type SandboxPricingCard = {
  object?: "sandbox.pricing" | undefined;
  rates?: { [k: string]: SandboxPriceRate } | undefined;
  updatedAt?: Date | null | undefined;
  updatedBy?: string | null | undefined;
};

/** @internal */
export const SandboxPricingCard$inboundSchema: z.ZodType<
  SandboxPricingCard,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("sandbox.pricing").default("sandbox.pricing"),
  rates: z.record(SandboxPriceRate$inboundSchema).optional(),
  updated_at: z.nullable(
    z.string().datetime({ offset: true }).transform(v => new Date(v)),
  ).optional(),
  updated_by: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "updated_at": "updatedAt",
    "updated_by": "updatedBy",
  });
});
/** @internal */
export type SandboxPricingCard$Outbound = {
  object: "sandbox.pricing";
  rates?: { [k: string]: SandboxPriceRate$Outbound } | undefined;
  updated_at?: string | null | undefined;
  updated_by?: string | null | undefined;
};

/** @internal */
export const SandboxPricingCard$outboundSchema: z.ZodType<
  SandboxPricingCard$Outbound,
  z.ZodTypeDef,
  SandboxPricingCard
> = z.object({
  object: z.literal("sandbox.pricing").default("sandbox.pricing" as const),
  rates: z.record(SandboxPriceRate$outboundSchema).optional(),
  updatedAt: z.nullable(z.date().transform(v => v.toISOString())).optional(),
  updatedBy: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    updatedAt: "updated_at",
    updatedBy: "updated_by",
  });
});

export function sandboxPricingCardToJSON(
  sandboxPricingCard: SandboxPricingCard,
): string {
  return JSON.stringify(
    SandboxPricingCard$outboundSchema.parse(sandboxPricingCard),
  );
}
export function sandboxPricingCardFromJSON(
  jsonString: string,
): SafeParseResult<SandboxPricingCard, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SandboxPricingCard$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SandboxPricingCard' from JSON`,
  );
}
